import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/dist/query/react';
import { SettingsState, getSettings } from '@vxui/common';
import { GenericMetric, PrometheusArgs, PrometheusMetric, PrometheusReponse } from '../models/metrics';

const rawBaseQuery = fetchBaseQuery();
const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const settings = getSettings(api.getState() as SettingsState);
  const urlEnd = typeof args === 'string' ? args : args.url;
  const adjustedUrl = `${settings?.servers.serverPrometheus ?? ''}/api/v1/${urlEnd}`;
  const adjustedArgs = typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl };
  return rawBaseQuery(adjustedArgs, api, extraOptions);
};

export const metricsApi = createApi({
  reducerPath: 'metricsApi',
  baseQuery: dynamicBaseQuery,
  endpoints: builder => ({
    getStats: builder.query<PrometheusMetric[], PrometheusArgs>({
      query: ({ query, time, subqueryTime }) =>
        `query?query=${encodeURIComponent(query)}${time ? `[${time}${subqueryTime ? `:${subqueryTime}` : ''}]` : ''}`,
      transformResponse: (response: PrometheusReponse<GenericMetric>) => {
        if (response.data.result) {
          return response.data.result.map(result => ({
            name: result.metric?.uuid ?? '',
            deviceName: result.metric?.label || result.metric?.mountpoint || result.metric?.device,
            values: result.values?.map(val => [val[0] * 1000, Number(val[1])]) || Number(result.value?.[1]) || 0,
          }));
        } else {
          return [];
        }
      },
    }),
  }),
});

export const { useGetStatsQuery } = metricsApi;
